module.exports = __webpack_public_path__ + "img/service_individual.3ce02d74.jpg";